import { z } from 'zod'

// Optional sub-fields use .nullish() (not .optional()): ContentStack returns an
// explicit `null` for an empty optional field, which .optional() would reject.
export const RawCmsCtaSchema = z
  .object({
    text: z.string(),
    intent: z.enum(['link', 'start_onboarding_wizard', 'start_onboarding_menu']).nullish(),
    variant: z.enum(['primary', 'secondary']).nullish(),
    href: z.string().nullish(),
  })
  .passthrough()
